import React from 'react';
import { Helmet } from 'react-helmet';
import Footer from '../components/Footer';
import logo from '../assets/images/logo.png';
import { StyledEngineProvider } from '@mui/material/styles';
import { navigate } from 'gatsby-plugin-intl';
import { NavBar } from '../components/NavBar';
import CTAButton from '../components/CTAButton';
import { useStaticQuery, graphql } from 'gatsby';
import LayoutBackground from '../components/LayoutBackground';
import Shuffler from '../components/Shuffler';
import { useMediaQuery } from '@mui/material';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config.js'; // this is going to bite me some day...
import { LayoutStateProvider } from './useLayoutState';
const fullConfig = resolveConfig(tailwindConfig);

const SizeInspector = () => (
  <div className="flex justify-between">
    <span className="hidden rounded-md bg-secondary-500 p-4 xs:inline">xs</span>
    <span className="hidden rounded-md bg-secondary-500 p-4 sm:inline">sm</span>
    <span className="hidden rounded-md bg-secondary-500 p-4 md:inline">md</span>
    <span className="hidden rounded-md bg-secondary-500 p-4 lg:inline">lg</span>
    <span className="hidden rounded-md bg-secondary-500 p-4 xl:inline">xl</span>
  </div>
);

export const withLayout = <P,>(
  Component: React.ComponentType<P>,
  pageTitle?: string
) => {
  const WrappedComponent = (props: P & { location }) => {
    const data = useStaticQuery(graphql`
      query {
        contentfulSite {
          siteTitle
          shortTitle
          siteDescription
          tagline
          socialLinks
        }
      }
    `);

    const isLargeScreen = useMediaQuery(
      `(min-width: ${fullConfig.theme.screens.md})`
    );

    const siteTitle = pageTitle
      ? `${data.contentfulSite.shortTitle} - ${pageTitle}`
      : data.contentfulSite.siteTitle;
    const siteDescription = data.contentfulSite.siteDescription;
    const year = React.useMemo(() => new Date().getFullYear(), []);
    return (
      <StyledEngineProvider injectFirst>
        <LayoutStateProvider>
          <LayoutBackground>
            <>
              <Helmet defer={true}>
                <title>{siteTitle}</title>
                <meta name="description" content={siteDescription} />
              </Helmet>
              <div className="flex h-[340px] w-full flex-col items-center justify-center pt-8 pb-4 backdrop-brightness-75 md:hidden">
                {/* ----------- MOBILE -----------  */}
                <img
                  onClick={() => navigate('/')}
                  src={logo}
                  alt="Site logo"
                  className="mb-4 w-64 cursor-pointer"
                />
                <div className="my-6 max-w-[360px] text-center text-sm  text-white opacity-75">
                  {data.contentfulSite.tagline}
                </div>
                {/* {(!!data.contentfulSite.tagline ||
                  !!data.contentfulSite.typelines) && (
                  <Shuffler
                    className="my-6 max-w-[360px] text-center text-sm  text-white opacity-75"
                    tagline={data.contentfulSite.tagline}
                    typelines={data.contentfulSite.typelines}
                  />
                )} */}
                {!isLargeScreen && <Footer />}
              </div>
              <div className="hidden h-full w-80 min-w-fit flex-col items-end p-2 backdrop-brightness-75 md:flex lg:p-4">
                {/* ----------- DESKTOP -----------  */}
                <img
                  onClick={() => navigate('/')}
                  src={logo}
                  alt="Site Logo"
                  className="w-48 cursor-pointer py-2 lg:w-60"
                />
                <div className="flex h-full flex-col items-end px-4 ">
                  <div className="max-w-[180px] text-right text-sm text-white opacity-75">
                    {data.contentfulSite.tagline}
                  </div>
                  {/* {(!!data.contentfulSite.tagline ||
                    !!data.contentfulSite.typelines) && (
                    <Shuffler
                      className="max-w-[180px] text-right text-sm text-white opacity-75"
                      tagline={data.contentfulSite.tagline}
                      typelines={data.contentfulSite.typelines}
                    />
                  )} */}
                  <div className="flex-grow" />
                  {isLargeScreen && <Footer />}
                </div>
              </div>

              <div className="flex flex-grow flex-col bg-white shadow-xl md:h-full md:overflow-scroll ">
                <div className="sticky top-0 z-[4] bg-white/90 px-4 pt-2 backdrop-blur sm:px-6 md:px-8 lg:px-16">
                  <CTAButton className="sm:hidden" />

                  <div className="mb-4 flex w-full border-b ">
                    <NavBar className="flex flex-grow justify-evenly gap-2 sm:justify-start sm:gap-6" />
                    <div className="hidden flex-grow sm:block" />
                    <CTAButton className="hidden sm:block" />
                  </div>
                </div>
                <div className="flex flex-col px-4 sm:px-6 md:px-8 lg:px-16 ">
                  <div
                    id="main"
                    className="flex-shrink scroll-mt-[6.7rem] md:scroll-mt-[4.2rem]"
                  >
                    <Component {...props} />
                  </div>
                </div>
                <div className="flex-grow" />
                <div className="mx-4 border-t sm:px-6 md:px-8 lg:px-16">
                  {/* <SizeInspector /> */}
                  <p className=" pt-16 pb-8">{`© ${data.contentfulSite.siteTitle} ${year}`}</p>
                </div>
              </div>
            </>
          </LayoutBackground>
        </LayoutStateProvider>
      </StyledEngineProvider>
    );
  };
  WrappedComponent.displayName = `${Component.displayName}WithLayout`;
  return WrappedComponent;
};
